require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-bic-provides-input-on-the-ida-21-draft-replenishmen.json") })
        }
      }, "path---en-us-update-bic-provides-input-on-the-ida-21-draft-replenishmen");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-bic-provides-input-on-the-ida-21-draft-replenishmen!./.cache/json/en-us-update-bic-provides-input-on-the-ida-21-draft-replenishmen.json
// module id = 628
// module chunks = 231608221292675